import { type ReactNode } from 'react';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
export const AiGradientButton = ({
  onClick,
  disabled,
  children,
  className
}: {
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
  className?: string;
}) => {
  return <Button className={cn(['from-violet-500 to-purple-400', 'disabled:from-violet-300 disabled:to-purple-200 disabled:opacity-[.54]', 'hover:from-violet-600 hover:to-purple-500', className])} intent={'gradient'} onClick={onClick} disabled={disabled} data-sentry-element="Button" data-sentry-component="AiGradientButton" data-sentry-source-file="AiGradientButton.tsx">
      {children}
    </Button>;
};